export function setAdobeFormSubmittedEvent(hearAboutFormValue, cidExists) {
    let event = cidExists  ? "LeadFormSubmit" : "anonUserFormSubmit";

    setAdobeEvent(event, hearAboutFormValue); 
}

export function setAdobeLeadResponseReceivedEvent(leadGenerated, cidExists) {
    let event = cidExists ? "LeadFormComplete" : "anonUserFormComplete";
    let eventLabel = leadGenerated ? "Lead generated" : "Lead not generated";

    setAdobeEvent(event, eventLabel);
}

function setAdobeEvent(event, eventLabel) {
    digitalData.eventInfo = {
        event: event,
        eventLabel: eventLabel
    };
}